import React, {Component} from "react"

class ReserverenView extends Component {
    render() {
        return (
            <div className="content container page-container">
                <div className="page-hero" style={{backgroundImage: "url('/images/reserveren/header2.png')"}}>
                    <div className="page-hero-overlay"></div>
                </div>

                <h1 className="page-title">Reserveren</h1>

                <div className="faq-card">
                    <div className="question">
                        Wat is het verschil tussen een reservatie en een oproep?
                    </div>
                    <div className="answer">
                        Wanneer u een ijskar reserveert op voorhand, bent u zeker dat we gaan langskomen op uw locatie.
                        Wanneer u een oproep plaatst, heeft u kans dat we langskomen als onze medewerkers in de buurt
                        zijn &amp; tijd hebben (dus als ze naar een reservatie moeten kan dit niet).
                    </div>
                </div>

                <div className="faq-card">
                    <div className="question">
                        Hoe moet ik een ijskar reserveren?
                    </div>
                    <div className="answer">
                        Simpel, klik hieronder op "Reserveer een ijskar!" en vul ons online formulier in.
                        U ontvangt onmiddellijk een offerte en kan deze ijskar dan aanvragen. We controleren wel
                        eerst manueel of we uw reservatie kunnen inplannen in onze planning. Wanneer dat is gebeurd
                        ontvangt u een bevestiging via mail en sms. 95% van de aanvragen kunnen we aanvaarden.
                    </div>
                </div>

                <div className="cta-section">
                    <a href="https://reservatie.foubert.eu" target="_blank" rel="noreferrer" className="btn">
                        Reserveer een ijskar!
                    </a>
                </div>
            </div>
        )
    }
}

export default ReserverenView
